import styled, { css } from 'styled-components';

const DetailItem = styled.div`
  &:first-child {
    .item-body {
      padding-top: 0;
    }
  }

  &:last-child {
    .item-body {
      padding-bottom: 0;

      .action-buttons {
        bottom: -16px;
      }
    }
  }

  .item-body {
    display: flex;
    padding: 8px 0;
    position: relative;
    ${({ withBorder }) =>
      withBorder &&
      css`
        border-bottom: 1px solid var(--color-border-default);
      `};

    .item-content {
      flex: 2;
      position: relative;
      word-break: break-word;
      color: var(--color-fg-weak);
    }

    .action-buttons {
      bottom: -2px;
      display: flex;
      position: absolute;
      right: -2px;
      z-index: 1;
    }

    ${({ hasActionButtons }) =>
      !hasActionButtons &&
      css`
        .action-buttons {
          display: none;
        }
      `}
  }

  .item-d-flex {
    .item-content {
      display: flex;
      flex: 2.5;
      justify-content: space-between;
      word-break: break-word;
    }
  }
`;

const DetailItemFooter = styled.div``;

const ItemButton = styled.button`
  align-items: center;
  background: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  box-shadow: var(--shadow-s);
  color: var(--color-accent-secondary-default);
  cursor: ${({ inactive }) => (inactive ? `not-allowed` : `pointer`)};
  display: flex;
  height: 28px;
  justify-content: center;
  margin-left: 3px;
  width: 28px;

  svg path {
    fill: ${({ inactive }) => (inactive ? `var(--color-accent-secondary-default)` : '')};
  }
`;

const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  height: fit-content;
  width: 200px;
`;

export { DetailItem, DetailItemFooter, ItemButton, TitleWrapper };
